import Api_Usermanagement from '../api-usermanagement'

const api = new Api_Usermanagement().init()

const getApproval = (module) => {
  return api.get(`/approval-level/${module}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getApprovalSearch = (module, sales, level, type, min, max, sector, pay) => {
  return api.get(
    `/approval-level/${module}?sales_org_code=${sales}&level=${level}&product_type=${type}&min_quantity=${min}&max_quantity=${max}&sector_id=${sector}&payment_type=${pay}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const createApproval = (module, data) => {
  return api.post(`/approval-level/create/${module}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const editApproval = (module, id, data) => {
  return api.put(`/approval-level/edit/${module}/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const deleteApproval = (id) => {
  return api.delete(`/approval-level/delete/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {getApproval, createApproval, editApproval, deleteApproval, getApprovalSearch}
